type ProductData = {
  value: number;
  currency: string;
  content_name: string;
  content_type: string;
  content_ids: string[];
  num_items: number;
};

declare global {
  interface Window {
    metaTrack?: (event: string, data: ProductData) => void;
    metaTrackInitiateCheckout?: (data: ProductData) => void;
    dataLayer?: Record<string, unknown>[];
  }
}

const PRODUCT_NAME = "Equilibrio 60+";
const PRODUCT_ID = "84da98c1-f8fb-49a7-90d8-18b283526d77";

export function parsePrice(text: string): number {
  let s = text.replace(/[^0-9.,]/g, "");
  if (s.indexOf(",") > -1) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else {
    const p = s.split(".");
    if (p.length > 1 && p[p.length - 1].length === 3) s = s.replace(/\./g, "");
  }
  return parseFloat(s) || 0;
}

function currency(): string {
  const el = document.getElementById("store-currency") as HTMLInputElement | null;
  return el && el.value ? el.value : "USD";
}

function productData(price: string): ProductData {
  return {
    value: parsePrice(price),
    currency: currency(),
    content_name: PRODUCT_NAME,
    content_type: "product",
    content_ids: [PRODUCT_ID],
    num_items: 1,
  };
}

function pushDataLayer(event: string, price: string) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      item_name: PRODUCT_NAME,
      value: parsePrice(price),
      currency: currency(),
    });
  } catch {
    /* noop */
  }
}

export function trackViewContent(price: string): () => void {
  pushDataLayer("ViewContent", price);
  if (typeof window.metaTrack === "function") {
    try {
      window.metaTrack("ViewContent", productData(price));
    } catch {
      /* noop */
    }
    return () => {};
  }
  let n = 0;
  const t = window.setInterval(() => {
    n++;
    if (typeof window.metaTrack === "function") {
      window.clearInterval(t);
      try {
        window.metaTrack("ViewContent", productData(price));
      } catch {
        /* noop */
      }
    } else if (n > 60) {
      window.clearInterval(t);
    }
  }, 150);
  return () => window.clearInterval(t);
}

export function trackInitiateCheckout(price: string) {
  try {
    if (typeof window.metaTrackInitiateCheckout === "function") {
      window.metaTrackInitiateCheckout(productData(price));
    }
  } catch {
    /* noop */
  }
  pushDataLayer("InitiateCheckout", price);
}
